module.exports = __webpack_public_path__ + "img/incomeGreen.e7144e9e.png";